import { defineStore } from 'pinia';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';

export const useSetupCredentialsStore = defineStore('setupCredentials', {
    state: () => ({
        setupCompleted: false,
        setupInProgress: false
    }),
    
    actions: {
        startSetup() {
            this.setupInProgress = true;
            this.setupCompleted = false;
        },
        
        completeSetup() {
            this.setupInProgress = false;
            this.setupCompleted = true;
        },
        
        resetSetup() {
            this.setupInProgress = false;
            this.setupCompleted = false;
        },

        async autoGenerateAdminCredentials(HttpService, apiCredentialsStore) {
            try {
                // Ottengo l'userId dal token JWT nei cookie
                const token = Cookies.get('exampleJwt', { domain: import.meta.env.VITE_BASE_URL_COOKIES });
                const decodedToken = jwtDecode(token);
                const userId = decodedToken.id;

                // Genera credenziali con permessi di amministratore
                const response = await HttpService.post('/credentials/generate', {
                    userId: userId,
                    permissions: ['admin']
                });

                // Salva le credenziali generate nello store
                const newCredentials = response.data;
                if (newCredentials && newCredentials.credentials) {
                    apiCredentialsStore.setCredentials(newCredentials.credentials);
                    this.completeSetup();
                    return true;
                }
                return false;
            } catch (error) {
                console.error('Errore durante la generazione automatica delle credenziali:', error);
                return false;
            }
        }
    },
    
    persist: true
}); 